<template>
    <v-main>
        <AppBar />
        <v-layout fill-height column>
            <v-container flex-fill fluid class="pt-0">
                <div class="py-5 ">
                    <div class="fs-12 fw-500 mb-2">{{ordDetail.ordCancelDt}}
                        <span class="fw-600 error--text ml-2">취소완료</span>
                    </div>
                    <div class="d-flex align-center justify-space-between ">
                        <div class="blueGrayDarken4--text">주문번호<span class="ml-1">{{ordDetail.ordNo}}</span></div>
                    </div>
                </div>
                <hr class="hr" />
                <div class="py-7">
                    <div class="fs-12 secondary--text mb-2">{{ ordDetail.ordDt }}</div>
                    <div class="d-flex justify-space-between" v-if="ordDetail.goodsClsfNm === '물성'">
                        <div>
                            <div class="d-flex align-center fs-18 fw-700"><span class="badge mr-2">{{ ordDetail.goodsClsfNm }}</span>{{ ordDetail.goodsNm }}</div>
                            <div class="secondary--text mt-2">{{ ordDetail.goodsDscrt }}</div>
                            <div class="fs-16 fw-700 primary--text line-height-1 mt-6">{{ ordDetail.saleAmt - ordDetail.dcAmt + 'C' | comma }}</div>
                        </div>
                        <div class="image">
                            <v-img :src="getImage('sample3.jpg')"></v-img>
                        </div>
                    </div>
                    <div class="d-flex justify-space-between" v-if="ordDetail.goodsClsfNm === '티켓'">
                        <div>
                            <div class="d-flex align-center fs-18 fw-700"><span class="badge mr-2">{{ ordDetail.goodsClsfNm }}</span>{{ ordDetail.goodsNm }}</div>
                            <div class="secondary--text mt-2">{{ ordDetail.goodsDscrt }}</div>
                            <div class="fs-16 fw-700 primary--text line-height-1 mt-6">{{ ordDetail.saleAmt - ordDetail.dcAmt + '원' | comma }}</div>
                        </div>
                    </div>
                </div>
                <hr class="hr" />
                <div class="purchase-info py-7">
                    <div class="list-title">취소 정보</div>
                    <v-divider class="my-4"></v-divider>
                    <div class="info-list">
                        <ul>
                            <li>{{ ordDetail.ordCancelRsonNm }}</li>
                            <li>{{ ordDetail.ordCancelRsonMemo }}</li>
                        </ul>
                    </div>
                </div>
                <hr class="hr" />
                <div class="py-7" v-if="ordDetail.goodsClsfNm === '물성'">
                    <div class="list-title">환불금액 정보</div>
                    <v-divider class="my-4"></v-divider>
                    <div class="d-flex flex-column gap-2 mb-5">
                        <div class="d-flex  gray200--text fw-500">결제금액</div>
                        <dl class="payment">
                            <dt>
                                상품금액
                            </dt>
                            <dd>
                                {{ ordDetail.saleAmt - ordDetail.dcAmt + 'C' | comma }}
                            </dd>
                        </dl>
                        <dl class="payment">
                            <dt>
                                배송비
                            </dt>
                            <dd>
                                {{ ordDetail.deliveryAmt + '원' | comma }}
                            </dd>
                        </dl>
                    </div>
                    <v-divider class="my-4"></v-divider>
                    <div class="d-flex flex-column gap-2 mb-5">
                        <div class="d-flex align-center fw-500">환불완료 <strong class="fs-12 error--text fw-500 ml-2">※결제수단인 코인은 원복됩니다.</strong></div>
                        <dl class="payment">
                            <dt>포인트 환급</dt>
                            <dd class="primary--text">{{ ordDetail.saleAmt - ordDetail.dcAmt + 'C' | comma }}</dd>
                        </dl>
                        <dl class="payment">
                            <dt>환불금액</dt>
                            <dd class="primary--text">{{ ordDetail.deliveryAmt + '원' | comma }}</dd>
                        </dl>
                    </div>
                </div>
                <div class="py-7" v-if="ordDetail.goodsClsfNm === '티켓'">
                    <div class="list-title">환불금액 정보</div>
                    <v-divider class="my-4"></v-divider>
                    <div class="d-flex flex-column gap-2 mb-5">
                        <div class="d-flex  gray200--text fw-500">결제금액</div>
                        <dl class="payment">
                            <dt>
                                티켓금액
                            </dt>
                            <dd>
                                {{ ordDetail.saleAmt - ordDetail.dcAmt + '원' | comma }}
                            </dd>
                        </dl>
                        <dl class="payment">
                            <dt>
                                쿠폰할인
                            </dt>
                            <dd>
                                {{ ordDetail.couponDcAmt + '원' | comma }}
                            </dd>
                        </dl>
                    </div>
                    <v-divider class="my-4"></v-divider>
                    <div class="d-flex flex-column gap-2 mb-5">
                        <div class="d-flex align-center fw-500">환불완료</div>
                        <dl class="payment">
                            <dt>환불금액</dt>
                            <dd class="primary--text">{{ (ordDetail.paymentAmt) + '원' | comma }}</dd>
                        </dl>
                    </div>
                </div>
            </v-container>
        </v-layout>
    </v-main>
</template>
<script>
import store from '@/store'
export default {
    data: () => ({
        ordDetail:{}
    }),
    components: {
    },
    created(){
        this.orderDetail();
    },
    methods:{
        async orderDetail(){
            await store.dispatch('orderDetail', this.$_payload({ordNo:this.$route.query.ordNo}))
            .then(res => {
               console.log(res);
               this.ordDetail = res.data;
            })
            .catch(error => {
                console.error(error)

            })
            .finally(() => {

            })
        },
    }
    ,filters:{
        comma(val){
            return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
}
</script>

<style lang="scss" scoped>
.badge {
    border: 1px solid var(--v-primary-base);
    padding: 0 10px;
    height: 22px;
    font-size: 12px;
    font-weight: 500;
    color: var(--v-primary-base);
    background: transparent;
    border-radius: 20px;
    width: auto;
    flex-shrink: 0;
}

.image {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
    margin-left: 12px;
}

.list-title {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 700;
    color: #212529;
    .v-btn.btn {
        background: $color-sub;
        border-radius: 20px;
        color: $color-main;
        font-size: 12px;
        font-weight: 400;
        height: 22px;
        padding: 0 12px;
        min-width: 20px;

    }
}

.payment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;

    dt {
        color: #B1B1B1;
    }

    dd {
        color: #9FA3A8;
        font-weight: 500;
    }
}

.purchase-info {
    display: flex;
    flex-direction: column;

    .info-list {
        display: flex;
        flex-direction: column;

        ul {
            display: flex;
            flex-direction: column;
            gap: 5px;

            li {
                line-height: 22px;
            }
        }
    }
}
</style>
